import script from "./form1View.vue?vue&type=script&setup=true&lang=js"
export * from "./form1View.vue?vue&type=script&setup=true&lang=js"

import "./form1View.vue?vue&type=style&index=0&id=26b81f8c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26b81f8c"]])

export default __exports__